import { useAppTheme } from './useAppTheme';

export { THEME_STORAGE_KEY } from './useAppTheme';

/**
 * Backwards-compatible layout-axis hook. Prefer {@link useAppTheme} for new
 * code that also needs the brand axis. Retained so existing consumers keep
 * working unchanged during the migration.
 */
export const useCompactTheme = () => {
  const { themeMode, isCompactTheme } = useAppTheme();
  return { themeMode, isCompactTheme };
};
